import axiosClient from './axiosClient';

const SurveyDashboardApi = {
  getDashboard: (payload) => {
    return axiosClient.post('/api/survey/dashboard', payload);
  },
};

export default SurveyDashboardApi;
